import { PettyCashCreatePage } from '@/features/petty-cash/pages/PettyCashCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/refund/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.create_refund"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: () => <PettyCashCreatePage type="refund" />,
})
